<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{$t('langNew.jdrz')}}</div>
        </div>
        <div class="bg">
            <ul class="list-box">
                <!-- <li class="list">
                    <div class="title">ASSET(USDT)</div>
                    <div class="money">3589.0000</div>
                </li> -->
                <li class="list list-code">
                  <div class="list-text">{{$t('usdttb.dz')}}</div>
                    <div class="input-box">
                        <input class="input" type="text" v-model="address" :placeholder="$t('usdttb.qsrdz')">
                        <div class="code" v-show="address" @click="copy($event)">{{$t('chongbi.fz')}}</div>
                    </div>
                </li>
                <li class="list">
                  <div class="list-text">{{$t('langNew.jiedian')}}</div>
                  <textarea class="textarea" type="textarea" v-model="node" :placeholder="$t('langNew.qsrje')"></textarea>
                </li>
                <button class="btn" type="button" v-if="ether_jdrz == 0" @click="sure">{{$t('xgdlmm.t7')}}</button>
                <button class="btn" type="button" v-else-if="ether_jdrz == 1">{{$t('langNew.rzz')}}</button>
                <button class="btn" type="button" v-else-if="ether_jdrz == 2">{{$t('langNew.yrz')}}</button>
                <button class="btn" type="button" v-else-if="ether_jdrz == -1" @click="sure">{{$t('langNew.rzsb')}}</button>
                <button class="btn" type="button" v-else @click="sure">{{$t('langNew.cxrz')}}</button>
              </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'nodeAuth',
    data () {
        return {
            uid: '',
            token: '',
            address: '',
            node: '',
            ether_jdrz: 0
        }
    },
    mounted(){
      this.address = localStorage.getItem('ethAddress') || '';
      this.token = localStorage.getItem('token');
      this.getInfo();
    },
    methods: {
      getInfo(){
        this.$ajax.post('/web/info').then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            this.ether_jdrz = resData.ether_jdrz || 0;
          }else{
            this.$router.push('/index');
          }
        }).catch(function(err){
            console.log(err)
        })
      },
        sure(){
           let params = {
              token: this.token,
              jiedian : this.node
            }
            if(this.node == '' || this.node == null){
               this.$toast.center(this.$t('langNew.qsrje'));
               return false;
            }
            this.$ajax.post('/web/jdrz',params).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 0){
                this.$toast.center(this.$t('status.statusText')[2]);
                setTimeout(()=>{
                  this.$router.push('/index');
                },1000)
              }
            }).catch(function(err){
                console.log(err)
            })
        },
        goBack(){
            this.$router.push('/index');
        },
        jump(){
            this.$router.push('/forgetTkPwd')
        },
        copy(e){
          if(this.address){
            let address = this.address;
            this.$copyText(address, this.$t('chongbi.fzcg'));
            this.$toast.center(this.$t('chongbi.fzcg'));
          }
        },
    },
     beforeDestroy(){
        clearInterval(this.timer);
        this.timer = null;
    }
}
</script>
<style scoped>
    input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{
        color: #fff;
        font-size: .4rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .52rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: relative;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        /* background: #0e1530; */
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .bg{
        position: absolute;
        width: 100%;
        height: calc(100% - .8rem);
        /* background: #0e1530; */
    }
    .list-box{
        padding: 0 .6rem;
        color: #ababab;
        /* background: #0e1530; */
    }
    .list-box .list .title{
      padding: .9rem 0 .8rem;
      color: #fff;
      font-size: .34rem;
      text-align: center;
    }
    .list-box .list .money{
      padding-bottom: .4rem;
      color: #fff;
      font-size: .75rem;
      text-align: center;
    }
    .list-box .list-text{
      position: relative;
      margin: .76rem 0 .4rem;
      padding-left: .2rem;
      color: #fff;
      font-size: .48rem;
    }
    .list-box .list-text::before{
      position: absolute;
      left: 0;
      top: 50%;
      content: "";
      width: .05rem;
      height: .42rem;
      background: #689ee8;
      transform: translateY(-50%);
    }
    .list-box .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 4px;
        background: rgba(244,244,244,.2);
    }
    .list-box .list .input{
        width: 100%;
        height: 1.24rem;
        padding: 0 .4rem;
        color: #d0d0d0;
        font-size: .48rem;
        background: rgba(244,244,244,.2);
        box-sizing: border-box;
    }
    .list-box .input-box .input{
      background: transparent;
    }
    .list-box .input-box .input{
        flex: 1;
        border: none;
    }
    .list-box .textarea{
      width: 100%;
      height: 2rem;
      padding: .2rem .4rem;
      color: #fff;
      font-size: .48rem;
      outline: none;
      box-sizing: border-box;
      background: rgba(244,244,244,.2);
    }
    .list-box .input-box .code{
      margin-right: .28rem;
      padding: .12rem .6rem;
      color: #fff;
      font-size: .34rem;
      border-radius: .1rem;
      background: #4458ed;
    }
    .tips{
        margin-top: .2rem;
        color: #2CAADE;
        font-size: .42rem;
        text-align: right;
    }
    .btn {
        width: 100%;
        height: 1.2rem;
        margin-top: 2.36rem;
        color: #fff;
        font-size: .48rem;
        line-height: 1.2rem;
        background: linear-gradient(left, rgba(44, 170, 222, 0.5), rgba(93, 205, 233, 0.5));
        border-radius: .2rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/nodeAuth.vue